import { Component, HostBinding, Input } from "@angular/core";
import { Router } from "@angular/router";
import {
    animate,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";
import { TranslateService } from "@ngx-translate/core";

import { EmbryoService } from "../../../Services/Embryo.service";
import { MarketingService } from "src/app/Services/marketing.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Component({
    selector: "embryo-SidebarMenu",
    templateUrl: "./SidebarMenu.component.html",
    styleUrls: ["./SidebarMenu.component.scss"],
    animations: [
        trigger("indicatorRotate", [
            state("collapsed", style({ transform: "rotate(0deg)" })),
            state("expanded", style({ transform: "rotate(180deg)" })),
            transition(
                "expanded <=> collapsed",
                animate("225ms cubic-bezier(0.4,0.0,0.2,1)")
            ),
        ]),
    ],
})
export class SideBarMenuComponent {
    expanded: boolean = false;
    expandedLv2: boolean = false;
    @Input() item: any;
    @Input() depth: number = 0;
    @HostBinding("attr.aria-expanded") ariaExpanded = this.expanded;
    @Input() lang = "";
    @Input() categoryId: any;
    isShopByPriceOpened: boolean = false;
    environmentVariables: any;
    constructor(
        public router: Router,
        public embryoService: EmbryoService,
        public translate: TranslateService,
        private confgServ: StaticPagesService,
        private marketingService: MarketingService
    ) {
        this.getInitilizingData();
        if (this.depth === undefined) this.depth = 0;
    }

    onItemSelected(item: any) {
        if (item.level2 && item.level2.length) this.expanded = !this.expanded;
        if (item.level3 && item.level3.length)
            this.expandedLv2 = !this.expandedLv2;
    }
    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }
    getCategoryId(item: any) {
      // console.log(item);
      
        if (item.link.includes("category_id")) {
            let path = item.link.split("?");
            var queryParams = this.getLinkQueryParams(path[1]);
            return queryParams.category_id;
        } else {
          // this.router.navigate([this.lang +'/category' + item.link])
            //  if(this.environmentVariables?.ENABLE_CATEGORY_VIEW){
            //         this.router.navigate([this.lang + "/category/" + item.link])
            //   }else if(!this.environmentVariables?.ENABLE_CATEGORY_VIEW){
            //       this.router.navigate([this.lang + '/product/' + item.link]);
            //   }else{
                return null;
              // }
        }
    }
    routing(item: any) {
      // console.log(item);
      // if(this.environmentVariables?.MENU_LINK_TYPE === 'slug'){
      //   if (item.link) {
      //          let linkSlashCount = item.link.split('/').length - 1;
      //               if(this.environmentVariables?.ENABLE_CATEGORY_VIEW && linkSlashCount  < 3){
      //               this.router.navigate([this.lang + "/category/" + item.link])
      //                }else{
      //                   this.router.navigate([this.lang + '/product/' + item.link]);
      //               }
      //                if(this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW){
      //                  this.router.navigate([this.lang + "/category/" + item.link])
      //                 }else if(!this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW){
      //                this.router.navigate([this.lang + '/product/' + item.link]);
      //                   }
      //                       this.embryoService.sidenavOpen = false;
      //      }
      //       }else{
            if (item.link) {
                  this.navigateToLink(item.link, item);
              } else if (item.id && item.name_en) {
                  this.handleCategoryRouting({
                      category_id: item?.id,
                      category_name: item?.name_en,
                  });
              }
              this.embryoService.sidenavOpen = false;
            // }
        
          }
    handleCategoryRouting(queryParams: any) {
        if (
            !this.environmentVariables?.ENABLE_CATEGORY_VIEW ||
            queryParams.sub_category_id
        ) {
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: queryParams,
            });
        } else {
            this.router.navigate(["/" + this.lang + "/category"], {
                queryParams: queryParams,
            });
        }
    }
    navigateToLink(link: any, item?: any) {
        if (link.includes("sub_category_id")) {
            let params = <any>this.getParams(link);
            this.marketingService.fbTracking("track", "SubCategoryMenu", {
                name: params.sub_category_id,
            });
            this.marketingService.snapTracking("track", "LIST_VIEW", {
                description: params.sub_category_id,
            });
        } else if (link.includes("category_id")) {
            let params = <any>this.getParams(link);
            this.marketingService.fbTracking("track", "CategoryMenu", {
                name: params.category_id,
            });
            this.marketingService.snapTracking("track", "LIST_VIEW", {
                name: params.category_id,
            });
        }

        if (link.includes("http") || link.includes("www")) {
            window.open(link, "_blank");
        } else if (link == "/") {
            this.router.navigate(["/"]);
        } else {
            let path = link.split("?");
            var queryParams = this.getLinkQueryParams(path[1]);

            if (this.categoryId) {
                queryParams.category_id = this.categoryId;
            }

            if (
                queryParams.category_id &&
                !queryParams.group_id &&
                !queryParams.sub_category_id &&
                this.environmentVariables?.ENABLE_CATEGORY_VIEW
            ) {
                this.router.navigate(["/" + this.lang + `/category`], {
                    relativeTo: null,
                    queryParams,
                });
            } else if (
                queryParams.group_id &&
                this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW
            ) {
                this.router.navigate(["/" + this.lang + `/category`], {
                    relativeTo: null,
                    queryParams,
                });
            }else {
                // this.router.navigateByUrl(this.lang + link);
                    if( link === '/pages/branches' || link === '/products/deals' || link ===  '/prescriptions' || link === ""){
                       this.router.navigate([this.lang  + link])
                    }else{
                         let linkSlashCount = link.split('/').length - 1;
                          if(this.environmentVariables?.ENABLE_CATEGORY_VIEW && linkSlashCount  < 3){
                          if(link === '/'){
                            link = ''
                           }
                           if(link === '/products/deals' || link ===  '/prescriptions' || link === ""){
                               this.router.navigate([this.lang  + link])
                            }else{
                             this.router.navigate([this.lang + "/category/" + link])
                            }
                           }else{
                            if(!link.includes('list_ids')){
                              this.router.navigate([this.lang + '/product/' + link]);
                            }else{
                                this.handleCategoryRouting({
                                     list_ids: link.split('=')[1],
                                })
                            }
                           }
                            if(this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW  && item?.level3){
                              this.router.navigate([this.lang + "/category/" + link])
                              }else if(!this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW && item?.level3 ){
                            this.router.navigate([this.lang + '/product/' + link]);
                         }
                 }
                
            }
        }
    }
    getLinkQueryParams(params: any = "") {
        let paramsArray = params.split("&");
        let paramsArrayWithValues: any[] = [];
        paramsArray.forEach((element: any) => {
            paramsArrayWithValues.push(element.split("="));
        });
        let queryParams: any = {};
        paramsArrayWithValues.forEach((element: any) => {
            queryParams[element[0]] = element[1];
        });
        return queryParams;
    }

    getParams(url: any) {
        var params = { pair: [""] };
        var parser = document.createElement("a");
        parser.href = url;
        var query = parser.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            params.pair[0] = decodeURIComponent(pair[1]);
        }
        return params;
    }
}
